import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        avatar: '',
        userId: '',
        productId: ""
    },
    getters: {
        getAvatar(state) {
            return state.avatar
        },
        userId(state) {
            return state.userId
        },
        productId(state) {
            return state.productId
        }
    },
    mutations: {
        // 改变头像
        changeAvatar(state, avatar) {
            state.avatar = avatar;
        },
        getUserId(state, userId) { //用户iD
            state.userId = userId
        },
        getProductId(state, productId) { //产品iD
            state.productId = productId
        }
    },
    actions: {},
    modules: {}
})